var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M13.2,5l-1.11,1.18l3.19,3.37h-4.46c-2.63,0-4.78,2.28-4.78,5.06V19h1.59v-4.39c0-1.86,1.43-3.37,3.19-3.37\nh4.46l-3.19,3.37l1.11,1.18l4.54-4.81c0.32-0.33,0.32-0.85,0-1.18L13.2,5L13.2,5z"}})}
var staticRenderFns = []

export { render, staticRenderFns }